
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/[go_id]",
      function () {
        return require("private-next-pages/special-offers/[go_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-offers/[go_id]"])
      });
    }
  